import Cookies from 'js-cookie';
import { path } from 'ramda';

import config from '../generated/config';

const { cookieDomain, brand, brandNumber } = config;

const legacyCookieNumber = brandNumber * 11000;

const cookiesDict = {
  customerId: 'customer.id',
  customerToken: 'customer.api.token',
  customerType: 'customerType',
  nickname: `${brand}Nick`,
  facebookAvatar: 'b2wFacebookAvatar',
  region: 'b2wRegion',
  device: 'b2wDevice',
  channel: 'b2wChannel',
  telemarketerToken: 'telemarketerToken',
  telemarketerId: 'telemarketerId',
  idLegacy: `${legacyCookieNumber}Customer`,
  isPrime: 'customer.isPrime',
  cPrivacyPolicy: 'c_privacyPolicy',
  cprime: 'c_prime',
  cfinance: 'c_finance',
  b2wSid: 'B2W-SID',
  b2wPid: 'B2W-PID',
  b2wUid: 'B2W-UID',
  b2wEPar: 'b2wEPar',
  b2wOpn: 'b2wOpn',
  b2wFranq: 'b2wFranq',
  b2wRegion: 'b2wRegion',
  b2wChannel: 'b2wChannel',
  b2wcrmts: 'b2wcrmts',
  gclid: 'gclid',
  b2wChave: 'b2wChave',
  afpid: 'affiliatedId',
  persistentCep: 'persistentCep',
  mesoRegion: 'mesoRegion',
  macroRegion: 'macroRegion',
  legionRegion: 'legionRegion'
};

const aempCookiesDict = {
  ...cookiesDict,
  customerId: 'aemp.customer.id',
  customerToken: 'aemp.customer.api.token',
  userEmail: 'aemp.user.email',
  panelDomain: 'domain.name'
};

const prtlCookiesDict = {
  ...cookiesDict,
  customerId: 'prtl.customer.id',
  customerToken: 'prtl.customer.api.token',
  userEmail: 'prtl.user.email',
  panelDomain: 'domain.name',
  warehouseId: 'warehouse.id',
  salesChannel: 'salesChannel',
  warehouseState: 'warehouse.state',
  withTax: 'withTax'
};

const getCookieDict = () => {
  if (brand === 'aemp') {
    return aempCookiesDict;
  }

  if (brand === 'prtl') {
    return prtlCookiesDict;
  }

  return cookiesDict;
};

export const channelDefaultValue =
  brand === 'acom' || brand === 'aemp' || brand === 'prtl' ? 'TSAL' : 'TELEVENDAS';

export const getCookie = cookieKey => {
  const validKey = path([cookieKey], getCookieDict());
  if (validKey) {
    return Cookies.get(validKey);
  }

  console.error(new Error(`can't get cookie key '${cookieKey}'`));

  return undefined;
};

export const safelySetCookie = (method, value) => {
  try {
    if (value !== undefined) {
      method(value);
    }
  } catch (err) {
    console.error(`Erro ao setar cookie com valor ${value}`, err);
  }
};

const defaultOpts = {
  path: '/',
  domain: cookieDomain
};

export const setCookie = (cookieKey, cookieValue, expires = 365) => {
  const validKey = path([cookieKey], getCookieDict());
  if (validKey) {
    const opts = expires ? { ...defaultOpts, expires } : defaultOpts;
    return Cookies.set(validKey, cookieValue, opts);
  }
  throw new Error(`can't set cookie key '${cookieKey}' to value '${cookieValue}'`);
};

export const removeCookie = cookieKey => {
  const validKey = path([cookieKey], getCookieDict());
  if (validKey) {
    return Cookies.remove(validKey, defaultOpts);
  }
  console.error(`can't remove cookie key '${validKey}'`);
};
